<template>
    <div v-if="visible" class="toast">{{ text }}</div>
</template>

<script setup lang="ts">
defineProps<{
    visible: boolean;
    text: string;
}>();
</script>

<style scoped>
.toast {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fb7299;
    color: #fff;
    padding: 10px 16px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 600;
    z-index: 2147483647;
    text-align: center;
    max-width: 80vw;
    word-break: break-word;
    box-shadow: 0 10px 26px rgba(251, 114, 153, 0.35);
}
</style>
